import { render, staticRenderFns } from "./SueldosRetiros.vue?vue&type=template&id=170a5aaa&"
import script from "./SueldosRetiros.vue?vue&type=script&lang=js&"
export * from "./SueldosRetiros.vue?vue&type=script&lang=js&"
import style0 from "./SueldosRetiros.vue?vue&type=style&index=0&id=170a5aaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports